export default __webpack_public_path__ + "static/quality-imported-parts-used-25e6d35e4a00b88323ff009ee635bf2b.jpg";